// src/config/firebase.js

import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Fonction pour récupérer la config Firebase depuis les variables d'environnement
const getFirebaseConfig = () => {
  const credentialsBase64 = process.env.REACT_APP_FIREBASE_CREDENTIALS_BASE64;
  
  // 1. Vérifier l'existence de la variable d'environnement
  if (!credentialsBase64) {
    console.error('[Firebase] REACT_APP_FIREBASE_CREDENTIALS_BASE64 is not defined in .env');
    throw new Error('Firebase credentials not found in environment variables');
  }

  // 2. Décoder la chaîne Base64 en JSON
  let decodedString;
  try {
    decodedString = atob(credentialsBase64);
  } catch (error) {
    console.error('[Firebase] Failed to decode Base64 string:', error);
    throw new Error('Failed to decode Base64 Firebase credentials. Check .env format.');
  }

  // 3. Parser le JSON décodé
  let decodedCredentials;
  try {
    decodedCredentials = JSON.parse(decodedString);
  } catch (error) {
    console.error('[Firebase] Failed to parse JSON from decoded credentials:', error);
    console.error('[Firebase] Decoded string was:', decodedString);
    throw new Error('Firebase credentials are not valid JSON');
  }

  // 4. Vérifier la présence des champs obligatoires
  if (!decodedCredentials.apiKey) {
    console.error('[Firebase] Missing "apiKey" in decoded credentials:', decodedCredentials);
    throw new Error('Firebase credentials missing "apiKey"');
  }
  if (!decodedCredentials.authDomain) {
    console.error('[Firebase] Missing "authDomain" in decoded credentials:', decodedCredentials);
    throw new Error('Firebase credentials missing "authDomain"');
  }

  // 5. Construire la config en laissant la possibilité de surcharger apiKey ou databaseURL
  const config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || decodedCredentials.apiKey,
    authDomain: decodedCredentials.authDomain,
    projectId: decodedCredentials.projectId,
    storageBucket: decodedCredentials.storageBucket,
    messagingSenderId: decodedCredentials.messagingSenderId,
    appId: decodedCredentials.appId,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
      || decodedCredentials.databaseURL
      || 'https://inspirehubdb-default-rtdb.europe-west1.firebasedatabase.app'
  };

  console.log('[Firebase] Final config loaded:', config);
  return config;
};

// 6. Initialiser Firebase
const app = initializeApp(getFirebaseConfig());

// 7. Exporter les clients dont vous avez besoin
const database = getDatabase(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { database, app, auth, googleProvider };
